import InfoLabel from '@/components/InfoLabel';
import { IPutAfterConfirmingBookingWorkflowRequest } from '@/types/workflows/IPutAfterConfirmingBookingWorkflowRequest';
import { Box, FormControl, Select } from '@chakra-ui/react';
import { t } from 'i18next';
import { UseFormReturn } from 'react-hook-form';

interface IProps {
	form: UseFormReturn<IPutAfterConfirmingBookingWorkflowRequest, any>;
	index: number;
}

export function OptionsCreateOOOEvent(props: IProps) {
	return (
		<Box mt={4} p={4}>
			<FormControl>
				<InfoLabel text={t('Calendar')} help={t('TimeTime will create evens in this calendar')} />
				<Select {...props.form.register(`actions.${props.index}.calendarId`)}>
					<option value="">Please select</option>
					<option value="iago@timetime.in">iago@timetime.in</option>
					<option value="iago.lastra@gmail.com">iago.lastra@gmail.com</option>
				</Select>
			</FormControl>
		</Box>
	);
}
